import useBridgeClient from "src/common/hooks/BridgeSWRClient";
import { endpoint } from "src/lib/bridgeClient";

export type TemplateDTO = {
  user_id?: string;
  organization_id?: number;
  template_name: string;
  blueprint_id: number;
  blueprint_name: string;
  active: boolean;
  id: number;
  body: TemplateBodyDTO;
};

export type TemplateBodyDTO = {
  scheduler_id: number;
  is_gpu: boolean;
  head_node_instance_type: string;
  compute_node_instance_type: string;
  volume_id?: string;
  tags: string;
  workflow_name: string;
};

export type TemplateResponse = {
  user: TemplateDTO[];
  organization: TemplateDTO[];
};

export const useGetTemplates = () => {
  const { data: templateResponse, error: templatesError } = useBridgeClient<TemplateResponse>(
    endpoint.myWorkflowTemplates
  );

  const templates = transformMyTemplates(templateResponse);

  return { data: templates, error: templatesError };
};

export const useGetOrgTemplates = (): { data: Array<Template>; error: Error } => {
  const { data: templateResponse, error: templatesError } = useBridgeClient<TemplateDTO[]>(
    endpoint.myOrgWorkflowTemplates
  );
  const templates = transform(templateResponse);

  return { data: templates, error: templatesError };
};

const transformMyTemplates = (data: TemplateResponse): Templates => {
  return {
    user: transform(data?.user),
    organization: transform(data?.organization),
  };
};

const transform = (data: Array<TemplateDTO>): Array<Template> => {
  return data?.map((template) => {
    return {
      id: template.id,
      userId: template.user_id,
      organizationId: template.organization_id,
      blueprintId: template.blueprint_id,
      blueprintName: template.blueprint_name,
      templateName: template.template_name,
      active: template.active,
      body: {
        workflowName: template.body?.workflow_name,
        isGPU: template.body?.is_gpu,
        headNodeInstanceType: template.body?.head_node_instance_type,
        computeNodeInstanceType: template.body?.compute_node_instance_type,
        tags: template.body?.tags,
        volumeId: template.body?.volume_id,
        schedulerId: template.body?.scheduler_id,
      },
    } as Template;
  });
};
